import { render } from "./ComponentSideBar.vue?vue&type=template&id=48deaafc&scoped=true"
import script from "./ComponentSideBar.vue?vue&type=script&lang=js"
export * from "./ComponentSideBar.vue?vue&type=script&lang=js"

import "./ComponentSideBar.vue?vue&type=style&index=0&id=48deaafc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48deaafc"]])

export default __exports__